import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';

import trunc from 'lodash/truncate';
import pluralize from 'pluralize';

import { editorialRoute } from '../../routes';
import CornerLabel from '../block/cornerLabel';

import css from './editorialElement.scss';

export default class CaseElement extends Component {
	static propTypes = {
		title: PropTypes.string.isRequired,
		excerpt: PropTypes.string.isRequired,
		slug: PropTypes.string.isRequired,
		types: PropTypes.object.isRequired,
		users: PropTypes.object.isRequired,
		menuActions: PropTypes.object.isRequired,
		menuActive: PropTypes.bool.isRequired,
	};
	static defaultProps = {
		title: '',
		excerpt: '',
		slug: '',
		types: {},
		users: {
			name: 'test',
		},
		menuActive: false,
	};

	constructor(props) {
		super(props);

		this.state = {};
	}

	render() {
		return (
			<div className='editorial-element'>
				<CornerLabel name={this.getCategory()} />
				<div className='editorial-element__category'></div>

				<div className='editorial-element__content '>
					<h2 className='editorial-element__content__title'>
						{this.props.title}
					</h2>
					<p className='editorial-element__content__excerpt'>
						{(this.props.excerpt.length > 90) ? trunc(this.props.excerpt, 82) + '…' : this.props.excerpt}
					</p>
				</div>

				<div className='editorial-element__author'>{this.getAuthor()}</div>

				<Link
					to={editorialRoute(this.props.slug)}
					className='editorial-element__link button'
					onClick={() => {
						this.props.menuActive && this.props.menuActions && this.props.menuActions.closeMenu();
					}
				}>
					Read More
				</Link>
			</div>
		);
	}

	getCategory() {
		return this.props.types.name ? pluralize(this.props.types.name, 1) : '';
	}

	getAuthor() {
		if (this.props.users && this.props.users.name && this.props.users.name.length) {
			return `By ${this.props.users.name}`;
		}

		return '';
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/editorial/editorialElement.js
 **/